export interface ICP {
  id: number;
  name: string;
  description?: string;
  is_default: boolean;
  job_title?: string;
  actual_duty_id?: number;
  what_i_actually_do?: string; // API field: string name of actual duty
  company_size_id?: number;
  industry_ids?: number[];
  what_is_my_main_challenge?: string;
  what_solutions_do_i_sell?: string;
  how_i_help_my_customers?: string;
  min_value_sold?: number;
  max_value_sold?: number;
  further_developments?: string;
  customer_company_size_ids?: number[];
  company_revenue_ids?: number[];
  customer_industry_ids?: number[];
  challenges_solved?: string;
  buying_cycle_id?: number;
  company_profitability?: string;
  location_numbers?: string;
  target_country_ids?: number[];
  trend_employee_id?: number;
  trend_revenue_id?: number;
  other_criteria?: string;
  open_jobs?: string;
  main_user_department_role?: string;
  main_user_role?: string;
  main_buyer_department?: string;
  main_buyer_job_title?: string;
  close_deal_id?: number;
  other_departments?: string;
  other_people?: string;
  country_exclusion_ids?: number[];
  workspaces_count?: number;
  created_at?: string;
  updated_at?: string;
  // Relations
  workspaces?: IcpWorkspace[];
  industries?: any[];
  target_company_sizes?: any[];
  target_company_revenues?: any[];
  target_industries?: any[];
  target_countries?: any[];
  actual_duty?: any;
  company_size?: any;
  customer_company_sizes?: any[];
  company_revenues?: any[];
  customer_industries?: any[];
  country_exclusions?: any[];
  trend_employee?: any;
  trend_revenue?: any;
  close_deal?: any;
  buying_cycle?: any;
  /** 'advanced_prospecting' for ICPs saved from a prospecting list. */
  source?: string | null;
  prospecting_meta?: { list_id?: string; summary_label?: string; total_companies?: number; list_only?: any[] } | null;
  /** Required fields still empty (prospecting ICPs only) — automation is blocked until completed. */
  missing_required?: string[] | null;
}

export interface IcpWorkspace {
  id: number;
  name: string;
  name_acronym: string;
  is_default: boolean;
  icp_id: number;
}

export interface IcpState {
  icps: {
    entities: ICP[];
    loading: boolean;
    error: string | null;
    pagination: {
      total: number;
      per_page: number;
      current_page: number;
      last_page: number;
      from: number;
      to: number;
    };
  };
  icpDetail: {
    entity: ICP | null;
    loading: boolean;
    error: string | null;
  };
  createIcp: {
    loading: boolean;
    success: boolean;
    error: string | null;
  };
  updateIcp: {
    loading: boolean;
    success: boolean;
    error: string | null;
  };
  deleteIcp: {
    loading: boolean;
    success: boolean;
    error: string | null;
  };
}

export const initialIcpState: IcpState = {
  icps: {
    entities: [],
    loading: false,
    error: null,
    pagination: {
      total: 0,
      per_page: 10,
      current_page: 1,
      last_page: 1,
      from: 0,
      to: 0
    }
  },
  icpDetail: {
    entity: null,
    loading: false,
    error: null
  },
  createIcp: {
    loading: false,
    success: false,
    error: null
  },
  updateIcp: {
    loading: false,
    success: false,
    error: null
  },
  deleteIcp: {
    loading: false,
    success: false,
    error: null
  }
};